const VIEW_MODES = [
  { value: "network", label: "Network" },
  { value: "compact", label: "Compact" },
  { value: "list", label: "List fallback" },
];

/** Header-band toolbar (Prompt 137): search + Network/Compact/List view-mode segmented control + Refresh - compact controls, no marketing hero. */
export default function OrgChartToolbar({ search, onSearchChange, viewMode, onViewModeChange, onRefresh }) {
  return (
    <div className="wx-oc-toolbar">
      <label className="wx-oc-search">
        <span className="wx-visually-hidden">ค้นหาชื่อหรือรหัส Super Agent, PLC, Agent</span>
        <input
          type="search"
          placeholder="ค้นหาชื่อหรือรหัส Super Agent, PLC, Agent..."
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </label>

      <div className="wx-oc-view-modes" role="group" aria-label="รูปแบบการแสดงผล">
        {VIEW_MODES.map((mode) => (
          <button
            key={mode.value}
            type="button"
            className={`wx-oc-view-mode-button${viewMode === mode.value ? " wx-oc-view-mode-button--active" : ""}`}
            aria-pressed={viewMode === mode.value}
            onClick={() => onViewModeChange(mode.value)}
          >
            {mode.label}
          </button>
        ))}
      </div>

      <button type="button" className="wx-button wx-button--ghost wx-oc-refresh-button" onClick={onRefresh}>
        Refresh
      </button>
    </div>
  );
}
